import includes from 'lodash/includes'

export const getProfilePictureUrl = (imageUrl = '') => {
  if(includes(imageUrl, 'amazonaws.com') || !includes(imageUrl, '/') ) {
    return `${process.env.REACT_APP_PROFILE_PICTURE_URL_PREFIX}${includes(imageUrl, '/') ? encodeURIComponent(imageUrl.slice(imageUrl.lastIndexOf('/')+1)) : encodeURIComponent(imageUrl)}`
  }
  return imageUrl
}

export const getInstokenLogoUrl = (imageUrl = '') => {
  if(includes(imageUrl, 'amazonaws.com') || !includes(imageUrl, '/') ) {
    return `${process.env.REACT_APP_INSTOKEN_LOGO_URL_PREFIX}${includes(imageUrl, '/') ? encodeURIComponent(imageUrl.slice(imageUrl.lastIndexOf('/')+1)) : encodeURIComponent(imageUrl)}`
  }
  return imageUrl
}



// WEBPACK FOOTER //
// ./src/utils/pictureUrlCreator/index.js